'use strict';



//////////////////
// WEBPACK FOOTER
// ./~/memoizee/lib/registered-extensions.js
// module id = 852
// module chunks = 4